import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Status Overview',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Change Impacts by Status',
                  slices: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Not Started',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'notStarted',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'In Progress',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'inProgress',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'In Review',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'inReview',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Complete',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'complete',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
    },
  },
  subqueries: {
    complete: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Complete',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inReview: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'In Review',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inProgress: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'In Progress',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    notStarted: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Not Started',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
